export default {
  isLoading: false,
  hasUnreadMessage: false
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/ui/state.js
// module id = null
// module chunks = 